async function sendReactNativePostMessage(postMessageData) {
  if (window?.ReactNativeWebView?.postMessage !== undefined) {
    await window.ReactNativeWebView.postMessage(
      JSON.stringify(postMessageData)
    );
  }
}

export default sendReactNativePostMessage;
